// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_footer__j4Bt6 {
  display: flex;
  justify-content: center;
  gap: 10px;
  border-radius: 16px;
  padding: 5px;
  background: rgb(247, 246, 255);
  position: fixed;
  z-index: 8000;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.style_footer__filled__IWQ7f {
  width: 100vw;
  background: rgb(247, 246, 255);
  padding-bottom: 25px;
  border-radius: 0;
  bottom: 0;
}
.style_footer__icon__VI0Op {
  font-size: 24px;
  color: #8d8d8d;
}
.style_footer__icon__active__CyLu7 {
  color: rgb(117, 83, 240);
}
.style_footer__item__f0jbC {
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 6px;
  position: relative;
}
.style_footer__item__active__\\+o9A9 {
  color: rgb(117, 83, 240);
}
.style_footer__item__main__idzaV {
  border: 1.5px solid rgb(213, 212, 220);
  border-radius: 12px;
}
.style_footer__item__text__jZr5L {
  font-size: 1rem;
  color: #8d8d8d;
  margin-top: 5px;
  font-weight: 700;
}
.style_footer__item__text__active__mVwRH {
  color: rgb(117, 83, 240);
}
.style_footer__item__notification__7DRhq {
  position: absolute;
  top: 1px;
  right: 15px;
  width: 14px;
  height: 14px;
  border-radius: 50px;
  background: #e73232;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_footer__item__notification__text__Y1Tzs {
  font-size: 0.9rem;
  color: rgb(255, 255, 255);
  font-weight: 700;
}
.style_footer__item__tooltip__pSGSF {
  position: absolute;
  top: -50px;
  left: 22px;
  opacity: 1;
  transition: opacity 1s ease-in-out;
}

.style_fadeIn__Tb2Dd {
  animation: style_fadeIn__Tb2Dd 1s forwards;
}

.style_fadeOut__f1l4W {
  animation: style_fadeOut__f1l4W 1s forwards;
}

@keyframes style_fadeIn__Tb2Dd {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes style_fadeOut__f1l4W {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,8BCJiB;EDMjB,eAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AAFF;AAIE;EACE,YAAA;EACA,8BCde;EDef,oBAAA;EACA,gBAAA;EACA,SAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;AAHJ;AAII;EACE,wBC5BC;AD0BP;AAME;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAJJ;AAMI;EACE,wBC1CC;ADsCP;AAMI;EACE,sCAAA;EACA,mBAAA;AAJN;AAOI;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AALN;AAMM;EACE,wBCvDD;ADmDP;AAQI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBCrDA;EDsDA,aAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAOM;EACE,iBAAA;EACA,yBCnEA;EDoEA,gBAAA;AALR;AAQI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,kCAAA;AANN;;AAWA;EACE,0CAAA;AARF;;AAWA;EACE,2CAAA;AARF;;AAWA;EACE;IACE,UAAA;EARF;EAUA;IACE,UAAA;EARF;AACF;AAWA;EACE;IACE,UAAA;EATF;EAWA;IACE,UAAA;EATF;AACF","sourcesContent":["@import 'public/assets/colors';\n\n.footer {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  border-radius: 16px;\n  padding: 5px;\n  background: $light-background;\n\n  position: fixed;\n  z-index: 8000;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  &__filled {\n    width: 100vw;\n    background: $light-background;\n    padding-bottom: 25px;\n    border-radius: 0;\n    bottom: 0;\n  }\n\n  &__icon {\n    font-size: 24px;\n    color: #8d8d8d;\n    &__active {\n      color: $main;\n    }\n  }\n\n  &__item {\n    width: 60px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 6px;\n    position: relative;\n\n    &__active {\n      color: $main;\n    }\n    &__main {\n      border: 1.5px solid $light-grey;\n      border-radius: 12px;\n    }\n\n    &__text {\n      font-size: 1rem;\n      color: #8d8d8d;\n      margin-top: 5px;\n      font-weight: 700;\n      &__active {\n        color: $main;\n      }\n    }\n\n    &__notification {\n      position: absolute;\n      top: 1px;\n      right: 15px;\n      width: 14px;\n      height: 14px;\n      border-radius: 50px;\n      background: $red;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      &__text {\n        font-size: 0.9rem;\n        color: $white;\n        font-weight: 700;\n      }\n    }\n    &__tooltip {\n      position: absolute;\n      top: -50px;\n      left: 22px;\n      opacity: 1;\n      transition: opacity 1s ease-in-out;\n    }\n  }\n}\n\n.fadeIn {\n  animation: fadeIn 1s forwards;\n}\n\n.fadeOut {\n  animation: fadeOut 1s forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `style_footer__j4Bt6`,
	"footer__filled": `style_footer__filled__IWQ7f`,
	"footer__icon": `style_footer__icon__VI0Op`,
	"footer__icon__active": `style_footer__icon__active__CyLu7`,
	"footer__item": `style_footer__item__f0jbC`,
	"footer__item__active": `style_footer__item__active__+o9A9`,
	"footer__item__main": `style_footer__item__main__idzaV`,
	"footer__item__text": `style_footer__item__text__jZr5L`,
	"footer__item__text__active": `style_footer__item__text__active__mVwRH`,
	"footer__item__notification": `style_footer__item__notification__7DRhq`,
	"footer__item__notification__text": `style_footer__item__notification__text__Y1Tzs`,
	"footer__item__tooltip": `style_footer__item__tooltip__pSGSF`,
	"fadeIn": `style_fadeIn__Tb2Dd`,
	"fadeOut": `style_fadeOut__f1l4W`
};
export default ___CSS_LOADER_EXPORT___;
